"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextRedlineDocumentation = exports.INHERITED_TYPOGRAPHY = void 0;
exports.legendOoxmlForAuthor = legendOoxmlForAuthor;
var _react = _interopRequireDefault(require("react"));
var _RedlinedText = require("@common/components/remedy/RedlinedText");
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _revisionStyle = require("@common/components/remedy/revision-style");
var _redlinePayload = require("@common/utils/redline/wire/redline-payload");
var _RevisionLegend = _interopRequireDefault(require("./RevisionLegend"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INHERITED_TYPOGRAPHY = exports.INHERITED_TYPOGRAPHY = {
  fontFamily: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  letterSpacing: "inherit"
};
var WORDPROCESSING_NAMESPACE = "http://schemas.openxmlformats.org/wordprocessingml/2006/main";
function escapeXmlAttribute(value) {
  return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}
function legendOoxmlForAuthor(author) {
  return "<w:document xmlns:w=\"".concat(WORDPROCESSING_NAMESPACE, "\"><w:ins w:author=\"").concat(escapeXmlAttribute(author), "\"/></w:document>");
}
function excerptOptionsFor(excerpt, changeAuthors, changeStamps, blockLimit) {
  return {
    contextUnits: excerpt.contextUnits,
    changeAuthors: changeAuthors,
    changeStamps: changeStamps,
    countsMovesAsChanges: true,
    blockLimit: blockLimit
  };
}
/** The rows a card adds, each cell underlined and painted as the author's revisions are, laid out as the grid Word received. */
var InsertedRowsDocumentation = function InsertedRowsDocumentation(_ref) {
  var rows = _ref.rows,
    paint = _ref.paint;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("table", {
    className: "mb-1.5 w-full border-collapse last:mb-0",
    "data-sentry-component": "InsertedRowsDocumentation",
    "data-sentry-source-file": "AppliedRedlineDocumentation.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
      children: rows.map(function (row, rowIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: row.map(function (cell, cellIndex) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
              className: "border border-[#D4D3D0] px-1.5 py-0.5 align-top",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: _objectSpread(_objectSpread({}, _revisionStyle.INSERTION_UNDERLINE), paint),
                children: cell
              })
            }, cellIndex);
          })
        }, rowIndex);
      })
    })
  });
};
var TextRedlineDocumentation = exports.TextRedlineDocumentation = function TextRedlineDocumentation(_ref2) {
  var textRedline = _ref2.textRedline,
    framed = _ref2.framed,
    _ref2$excerpt = _ref2.excerpt,
    excerpt = _ref2$excerpt === void 0 ? null : _ref2$excerpt;
  var authorColorOf = (0, _RedlineAuthorColorsContext.useRedlineAuthorColor)();
  var changedParagraphs = textRedline.paragraphs.filter(function (paragraph) {
    return paragraph.textProposed !== paragraph.textWhenProposed;
  });
  var _textRedline$tableCha = textRedline.tableChanges,
    rowInsertions = _textRedline$tableCha.rowInsertions,
    rowDeletions = _textRedline$tableCha.rowDeletions,
    tableInsertions = _textRedline$tableCha.tableInsertions;
  var changesATable = (0, _redlinePayload.carriesTableOperations)(textRedline.tableChanges);
  if (changedParagraphs.length === 0 && textRedline.insertions.length === 0 && !changesATable) return null;
  var paint = (0, _revisionStyle.revisionPaintOf)(textRedline.author, authorColorOf);
  var paragraphExcerpt = excerpt === null ? null : excerptOptionsFor(excerpt, [textRedline.author], [], null);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: framed ? "mt-2" : undefined,
    "data-sentry-component": "TextRedlineDocumentation",
    "data-sentry-source-file": "AppliedRedlineDocumentation.tsx",
    children: [excerpt === null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RevisionLegend.default, {
      ooxml: legendOoxmlForAuthor(textRedline.author),
      alwaysListedAuthors: []
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: framed ? "box-border w-full rounded border border-[#D4D3D0] bg-white p-2 text-[12px] leading-[1.4] text-[#1f2937]" : "w-full",
      children: [changedParagraphs.map(function (paragraph, index) {
        var _paragraph$bookmark;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "mb-1.5 last:mb-0",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinedText.RedlinedText, {
            textBefore: paragraph.textWhenProposed,
            text: paragraph.textProposed,
            author: textRedline.author,
            changeExcerpt: paragraphExcerpt
          })
        }, (_paragraph$bookmark = paragraph.bookmark) !== null && _paragraph$bookmark !== void 0 ? _paragraph$bookmark : "paragraph-".concat(index));
      }), textRedline.insertions.map(function (insertion, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "m-0 mb-1.5 last:mb-0",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: _objectSpread(_objectSpread({}, _revisionStyle.INSERTION_UNDERLINE), paint),
            children: insertion.textProposed
          })
        }, "".concat(insertion.afterBookmark, "-").concat(index));
      }), rowInsertions.map(function (insertion, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(InsertedRowsDocumentation, {
          rows: insertion.rows,
          paint: paint
        }, "rows-".concat(insertion.afterRowOfBookmark, "-").concat(index));
      }), tableInsertions.map(function (insertion, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(InsertedRowsDocumentation, {
          rows: insertion.rows,
          paint: paint
        }, "table-".concat(insertion.afterBookmark, "-").concat(index));
      }), rowDeletions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "m-0 mb-1.5 last:mb-0",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: _objectSpread({
            textDecoration: "line-through"
          }, paint),
          children: rowDeletions.length === 1 ? "1 table row" : "".concat(rowDeletions.length, " table rows")
        })
      })]
    })]
  });
};